import { Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounce, Subject, timer } from 'rxjs';

@Component({
  selector: 'app-range-menu-element',
  imports: [],
  template: `
    <div class="input-cell">
      <label [for]="unit() + '-min'">{{ unit() || 'min' }}</label>
      <input
        [id]="unit() + '-min'"
        type="number"
        [value]="min() ?? ''"
        (input)="setRangeValue($event, 'min')"
      />
    </div>
    <span>to</span>
    <div class="input-cell">
      <label [for]="unit() + '-max'">{{ unit() || 'max' }}</label>
      <input
        [id]="unit() + '-max'"
        type="number"
        [value]="max() ?? ''"
        (input)="setRangeValue($event, 'max')"
      />
    </div>
  `,
  styleUrl: './range-menu-element.scss',
})
export class RangeMenuElement {
  unit: InputSignal<string | undefined> = input();
  min: InputSignal<number | undefined> = input();
  max: InputSignal<number | undefined> = input();
  debounceMs: InputSignal<number> = input<number>(400);
  minChange: OutputEmitterRef<number | undefined> = output();
  maxChange: OutputEmitterRef<number | undefined> = output();
  private minValueChanges: Subject<number | undefined> = new Subject<number | undefined>();
  private maxValueChanges: Subject<number | undefined> = new Subject<number | undefined>();

  constructor() {
    this.minValueChanges
      .pipe(debounce(() => timer(this.debounceMs())), takeUntilDestroyed())
      .subscribe((value: number | undefined) => this.minChange.emit(value));

    this.maxValueChanges
      .pipe(debounce(() => timer(this.debounceMs())), takeUntilDestroyed())
      .subscribe((value: number | undefined) => this.maxChange.emit(value));
  }

  setRangeValue(event: Event, type: 'min' | 'max'): void {
    const inputValue: string = (event.target as HTMLInputElement).value;
    const value: number | undefined = inputValue === '' ? undefined : Number(inputValue);

    if (type === 'min') {
      this.minValueChanges.next(value);
      return;
    }

    this.maxValueChanges.next(value);
  }
}
